// extracted by mini-css-extract-plugin
export default {"color-off-white":"#f8f8f8","colorOffWhite":"#f8f8f8","large":"only screen and (min-width: 992px)","homepageRail":"vjPJp","homepageRailList":"_18607"};